import { useTranslation } from 'react-i18next'
import { ImageIcon } from 'lucide-react'
import { screenDisplayStatus, type ScreenStatusLike } from '@meno/ui/components/shared/ScreenStatusBadge'

// Operator-facing surface for a screen whose license has expired but is
// gracefully handling it (Enterprise plan — see
// app/services/license_fallback.py): the screen stayed paired and is
// showing the org's fallback image instead of dropping to a pairing code.
// Mutually exclusive with ExpiredScreenBanner — screenDisplayStatus resolves
// to exactly one of "expired" / "license_fallback" for a given screen.
// Calm blue, not the destructive-red ExpiredScreenBanner uses — nothing is
// broken here, no action is required, it recovers on its own once renewed.
export default function LicenseFallbackBanner({ screen }: { screen: ScreenStatusLike }) {
  const { t } = useTranslation()
  if (screenDisplayStatus(screen) !== 'license_fallback') return null

  return (
    <div className="shrink-0 mx-[var(--space-l)] mt-[var(--space-l)] flex items-center gap-3 rounded-xl border border-blue-500 bg-blue-500 px-4 py-3 text-white">
      <ImageIcon className="w-5 h-5 shrink-0" />
      <p className="min-w-0 flex-1 text-sm font-semibold">
        {t('screens.licenseFallbackTitle', 'License expired')} — {t('screens.licenseFallbackBody', 'showing your fallback image until it’s renewed. No action needed.')}
      </p>
    </div>
  )
}
